import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MentionNodeAttrs } from '@tiptap/extension-mention';
import { getListActivities } from 'Store/Activities/Activities.selector';
import { getTheme } from 'Store/MultiDomain/MultiDomain.selector';
import MentionActivityComponentRender from './MentionActivityComponentRender';

export interface IMentionUserStaticDisplay {
  node: {
    attrs: MentionNodeAttrs;
  };
}

const MentionActivityStaticDisplay: FC<IMentionUserStaticDisplay> = ({ node }) => {
  const { id } = node.attrs as MentionNodeAttrs;
  const theme = useSelector(getTheme);
  const listActivities = useSelector(getListActivities);

  const activity = useMemo(() => {
    if (!listActivities?.activities || !id) return null;
    return listActivities?.activities[id];
  }, [listActivities, id]);
  
  if (!activity) {
    return null;
  }

  return <MentionActivityComponentRender activity={activity} theme={theme} />;
};

export default MentionActivityStaticDisplay;
